import { Box, Card } from '@mui/material';
import type { ReactNode } from 'react';

/**
 * Shared outer frame for the analytical-variable content-card tabs
 * (Definition / SQL / Verification). Mirrors the gen-3 cohort detail tabs:
 * an outlined card sitting in a 24px horizontal / 12px vertical gutter, so
 * the AV and cohort detail pages read as the same workspace surface.
 *
 * The card is a plain padded container — each tab owns its own internal
 * layout (prose sections, the SQL row, the execution stack).
 */
export const ArtifactTabCard = ({
  children,
  'data-testid': dataTestId,
}: {
  children: ReactNode;
  'data-testid'?: string;
}) => (
  <Box sx={{ paddingX: 6, paddingY: 3 }}>
    <Card variant="outlined" sx={{ padding: 6, minWidth: 0 }} data-testid={dataTestId}>
      {children}
    </Card>
  </Box>
);
